import { StatusBar } from 'expo-status-bar';
import Routes from './src/routes'
import { useFonts } from 'expo-font';
// import * as serviceWorkerRegistration from "./src/serviceWorkerRegistration";

export default function App() {
  const [fontsLoaded] = useFonts({
    'Nunito': require('./assets/fonts/Nunito-Regular.ttf'),
  });
  if (!fontsLoaded) {
    return null;
  }

  return (
    <>
      <StatusBar style="auto" />
      <Routes/>
    </>
  );
}


// serviceWorkerRegistration.register();